import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Train = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      d="M4 7.799h15.579M4 13.034h15.579M12 8.235v4.799M7.79 15.65v.873m8.42-.873v.873M16.067 22l-1.12-2.422M7.933 22l1.12-2.422M4 6.49C4 4.563 5.508 3 7.368 3h9.264C18.492 3 20 4.563 20 6.49v9.598c0 1.927-1.508 3.49-3.368 3.49H7.368c-1.86 0-3.368-1.563-3.368-3.49z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Train) as SvgIcon;
export { ForwardRef as ReactComponent };
